import { ZeroRecurringCreditsWarningProps } from '../../types/components/checkout/ZeroRecurringCreditsWarning';

import { QuestionIcon } from '../../modules/Icons';
import { Tooltip } from 'react-tooltip';

const ZeroRecurringCreditsWarning: React.FC<ZeroRecurringCreditsWarningProps> = ({
  selectedPlanVariant,
}) => {
  if (selectedPlanVariant.recurring_credits > 0) return;

  const tooltipId = 'zero-recurring-credits-tooltip';

  return (
    <div className="flex w-full text-a-gray items-center" cy-test-id="zero-recurring-credits-warning">
      <span className="text-14">
        Zero Recurring Credits Included
      </span>
      <QuestionIcon
        data-tooltip-id={tooltipId}
        className={`ml-auto text-a-gray`}
      />
      <Tooltip
        id={tooltipId}
        className="max-w-[300px] z-50 !text-[14px] !normal-case leading-[22px] rounded-[5px] py-[10px] shadow tooltip"
        opacity={1}
        clickable={true}
        style={{ backgroundColor: 'black' }}
      >
        This plan does not include any recurring credit allotments. You can still purchase credits individually as needed.
      </Tooltip>
    </div>
  );
};

export default ZeroRecurringCreditsWarning;
